"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scheduleAtInterval = void 0;
/*
 * @param {number} interval - number of milliseconds to wait after a task is completed
 */
const scheduleAtFixedRate_1 = require("./scheduleAtFixedRate");
const abortableTimers_1 = require("./abortableTimers");
const scheduleAtInterval = async (task, interval, executeAtStart, abortSignal) => {
    if (abortSignal?.aborted) {
        return;
    }
    if (executeAtStart) {
        await task();
    }
    (0, scheduleAtFixedRate_1.repeatScheduleTask)((doneCb) => {
        (0, abortableTimers_1.setAbortableTimeout)(async () => {
            await task();
            doneCb();
        }, interval, abortSignal);
    }, abortSignal);
};
exports.scheduleAtInterval = scheduleAtInterval;
//# sourceMappingURL=scheduleAtInterval.js.map